<template>
    <div>		
		<p-card class="overflow-hidden tw-p-none">
			<v-layout row tw-px-10 tw-py-8>
				<v-flex xs6 tw-pl-1 tw-pt-1>
						<p class="title-select">Selecciona el tipo de pregunta para la evaluación:</p>
				</v-flex>
				<v-flex xs4 tw-pl-1 tw-pt-1>
						<v-select
							label="Tipo de Pregunta"
							class="select-core"
							hide-details
							:menu-props="{ contentClass: 'type-select-content' }"
							height="37"
							outline
							clearable
							single-line
							:items="answers"
							item-value="id"
							item-text="name"
							v-model="answerId"
							return-object
							@input="getAnswer($event)"
						></v-select>
				</v-flex>
			</v-layout>
			<v-layout row tw-px-10 tw-pb-10>
				<v-flex xs6 tw-pl-1 tw-pt-1>
					<p class="title-box">Alternativas de Evaluación:</p>
					<div class="line"></div>
					<table class="table-evaluation">
						<tr>
							<th>Descripción:</th>
							<th>Valor:</th>
						</tr>
						<tr v-for="(detail, index) in details" :key="index">
							<td style="font-size: smaller;">{{ detail.name }}</td>
							<td style="font-size: smaller;">{{ detail.value }}</td>
						</tr>
					</table>
				</v-flex>
			</v-layout>
			<p-horizontal-divider class="tw-m-none" />
			<div class="tw-text-center tw-p-6">
				<p-button @click="handlePrevStep()" type="primary" class="tw-px-12">
					Atrás
				</p-button>
				<p-button
					@click="$emit('saveClick')"
					type="secondary"
					:disabled="!answerId"
				>
					Guardar
				</p-button>
			</div>
		</p-card>
    </div>
</template>

<script>
import PCard from '../../../shared/components/ui/Card/p-card';
import PHorizontalDivider from '../../../shared/components/ui/p-horizontal-divider';
import PButton from '../../../shared/components/ui/p-button';
import { tseNamespace } from '../../utils';

function created() {
	this.loadData();
}

async function loadData() {
	try {
		const { data: response } = await this.$http.get('answers');
		this.answers = response;
	} catch (error) {
		this.showGenericError();
	}
}

function getAnswer(ans) {
	this.details = ans.details;
	this.$emit('getAnswerId', ans.id);
}

export default {
	name: 'SelectedAnswer',
	created,
	components: {
		PButton,
		PCard,
		PHorizontalDivider,
	},
	props: {
	},
	data() {
		return {
			answers: [],
			answerId: null,
			details: [],
		};
	},
	computed: {
	},
	methods: {
		loadData,
		getAnswer,
		handlePrevStep() {
			this.$store.dispatch(tseNamespace('prevStep'));
		},
	},
	watch: {
	},
};

</script>

<style lang="scss" scoped>
.title-select {
	color: color(green-light);
	font-size: size(large);
	padding-top: 8px;
}
.title-box {
	color: color(green-light);
	margin: 0 !important;
	padding: 0 !important;
}

.line {
	width: 40%;
	margin-bottom: 10px;
	border: 1px solid color(green-light);
}
.table-evaluation {
	width: 100%;
	border: 1px solid color(border-gray);
	border-collapse: collapse;
	text-align: center;
	tr {
		th, td {
			border: 1px solid color(border-gray);
			padding: 5px;
		}
		th {
			color: color(orange-dark);
			font-size: size(large);
		}
		td {
			color: color(gray-medium);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/fourth-step/selected-answer.vue